import DragHandleIcon from '@mui/icons-material/DragHandle';
import { Box } from '@mui/material';
import { DraggableProvided } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import { CostTypeDto } from '../../common/PricePrgClient';
import { RootState } from '../../store';
import { getCostType } from './calculationTypes';
import { getSelectedCalculationPricelistCurrency } from './redux/calculationSelectors';

type OwnProps = {
    costType: CostTypeDto;
    provided: DraggableProvided;
};
const mapStateToProps = (state: RootState) => ({
    currency: getSelectedCalculationPricelistCurrency(state)
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const CostType = ({ currency, costType, provided }: Props) => {
    return (
        <Box
            component="div"
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            sx={{
                padding: '3px',
                margin: '8px',
                border: '2px solid lightgrey',
                backgroundColor: 'white',
                alignItems: 'center',
                display: 'flex'
            }}
        >
            <DragHandleIcon sx={{ display: 'inline-block', color: 'lightgrey' }} />
            {getCostType(currency, costType.value!)}
        </Box>
    );
};
export default connect(mapStateToProps)(CostType);
